import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import Storage from '../../../services/Storage';

import InactivityTimerBanner from '../components/InactivityTimerBanner';
import { startRequest as logoutRequest } from '../../Authorization/redux/logout/actions';
import config from '../../../config';

export default connect(
  createStructuredSelector({
    config: () => config,
    token: () => Storage.getItem(config.tokenItemName),
  }),
  (dispatch) =>
    bindActionCreators(
      {
        logoutRequest,
      },
      dispatch,
    ),
)(InactivityTimerBanner);
